import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./features.css";
import Feature1 from "./images/feature-1.png";
import Feature2 from "./images/feature-2.png";
import Feature3 from "./images/feature-3.png";

const Features: React.FC = () => {
    return (
        <section id="features">
            <div className="container">
                <div className="row">
                    {/* Coluna Esquerda */}
                    <div className="col-md-6 d-flex flex-column justify-content-center">
                        <div className="feature-text margin-feature-1">
                            <h2>Acelere o Sucesso do Seu Negócio com Estratégias Inteligentes</h2>
                            <p>Impulsione o crescimento do seu negócio de forma rápida e eficiente, alcançando mais clientes e aumentando sua visibilidade no mercado.</p>
                        </div>
                        <div className="feature-image">
                            <img src={Feature2} alt="Gerenciamento de links" className="img-fluid" />
                        </div>
                        <div className="feature-text margin-feature-2">
                            <h2>Atendimento Especializado para te Ajudar a Qualquer Momento</h2>
                            <p>Conte com um suporte especializado sempre que precisar! Nossa equipe está pronta para oferecer assistência rápida e eficiente, garantindo que você tenha a melhor experiência possível e aproveite ao máximo nossos serviços.</p>
                        </div>
                    </div>

                    {/* Coluna Direita */}
                    <div className="col-md-6 d-flex flex-column justify-content-center">
                        <div className="feature-image">
                            <img src={Feature1} alt="Personalização" className="img-fluid" />
                        </div>
                        <div className="feature-text margin-feature-3">
                            <h2>Personalize do seu jeito</h2>
                            <p>Adicione imagens, vídeos e botões para transformar sua página em uma experiência visualmente impactante e totalmente personalizada, garantindo mais engajamento e atração para seu público.</p>
                        </div>
                        <div className="feature-image">
                            <img src={Feature3} alt="Métricas de desempenho" className="img-fluid" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Features;
